export default "__VITE_PUBLIC_ASSET__d7aa7f29__"